import { Component, OnInit, inject } from '@angular/core';
import {TranslationService} from "../../../core/services/translation.service";
import {ConfigService} from "../../../core/services/config.service";
import {NavigationCommand, NavigationService} from "../../../data/services/navigation.service";

import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-contact-overview',
  templateUrl: './contact-overview.component.html',
  styleUrls: ['./contact-overview.component.css'],
  imports: [
    MatButton
],
  standalone: true
})
export class ContactOverviewComponent implements OnInit {
  translationService = inject(TranslationService);
  private configService = inject(ConfigService);
  private navigationService = inject(NavigationService);


  showBackToOverviewButton: boolean;

  ngOnInit(): void {
    this.showBackToOverviewButton = this.configService.getConfig('show.backToOverView.button')?.asBoolean();
  }

  backToOverview(): void {
    this.navigationService.navigateTo(NavigationCommand.CONTACT, null, true);
  }

}
